/* Harbour & Forge — product page (hf-main-product section). */
(function () {
  if (customElements.get('hf-product')) return;

  const SWATCHES = {
    'carbon grey': '#4a4a4a',
    'military green': '#4b5320',
    'charcoal heather': '#4a4d52',
    charcoal: '#36454f',
    'charcoal gray': '#36454f',
    'charcoal grey': '#36454f',
    'aqua blue': '#00b5d8',
    gold: '#d4a017',
    gray: '#808080',
    grey: '#808080',
    'kelly green': '#4cbb17',
    khaki: '#c3b091',
    'light grey': '#d3d3d3',
    'light gray': '#d3d3d3',
    midnight: '#14213d',
    shadow: '#5b5b5b',
    walnut: '#5c4033',
    storm: '#6b7280',
    'navy blue': '#1f2a44',
    'sky blue': '#87ceeb',
    'mild apricot': '#fbdcc4',
    apricot: '#fbceb1',
    coffee: '#6f4e37',
    'oat gray': '#cfc8b8',
    'oat grey': '#cfc8b8',
    'flower gray': '#b8b8b8',
    'flower grey': '#b8b8b8',
    natural: '#e8dcc4',
  };

  function swatchColor(value) {
    const key = String(value).split('/')[0].trim().toLowerCase();
    return SWATCHES[key] || key.replace(/[^a-z]/g, '');
  }

  function formatMoney(cents) {
    const config = window.hfQuickAddConfig || {};
    const format = config.moneyFormat || '${{amount}}';
    const amount = cents / 100;
    const withDelimiters = (n, decimals, thousands, decimal) => {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return withDelimiters(amount, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(amount, 0, '.', ',');
        default:
          return withDelimiters(amount, 2, ',', '.');
      }
    });
  }

  class HfProduct extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-product-json]');
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.strings = Object.assign(
        { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable', error: 'Could not add to cart. Please try again.' },
        (window.hfQuickAddConfig && window.hfQuickAddConfig.strings) || {}
      );

      this.slides = this.querySelector('.hf-pdp__slides');
      this.prev = this.querySelector('.hf-pdp__arrow--prev');
      this.next = this.querySelector('.hf-pdp__arrow--next');
      this.thumbs = Array.from(this.querySelectorAll('.hf-pdp__thumb button'));
      this.form = this.querySelector('.hf-pdp__form');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      this.submit = this.querySelector('.hf-pdp__submit');
      this.priceEl = this.querySelector('[data-price]');
      this.skuEl = this.querySelector('[data-sku]');
      this.errorEl = this.querySelector('.hf-pdp__error');

      this.querySelectorAll('[data-swatch]').forEach((label) => {
        label.style.setProperty('--hf-swatch', swatchColor(label.dataset.swatch));
      });

      this.selected = Array.from(this.querySelectorAll('.hf-pdp__option')).map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      this.addEventListener('change', (event) => {
        const fieldset = event.target.closest('.hf-pdp__option');
        if (!fieldset) return;
        this.selected[Number(fieldset.dataset.index)] = event.target.value;
        this.update(true);
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.add();
        });
      }

      this.bindGallery();
      this.markAvailability();
    }

    /* ---------- gallery ---------- */

    slideStep() {
      const first = this.slides.children[0];
      if (!first) return 0;
      const gap = parseFloat(getComputedStyle(this.slides).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    goTo(index, smooth) {
      if (!this.slides) return;
      this.slides.scrollTo({ left: index * this.slideStep(), behavior: smooth === false ? 'auto' : 'smooth' });
    }

    bindGallery() {
      if (!this.slides) return;
      const sync = () => {
        const step = this.slideStep() || 1;
        const index = Math.round(this.slides.scrollLeft / step);
        if (this.prev) this.prev.disabled = this.slides.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.slides.scrollLeft >= this.slides.scrollWidth - this.slides.clientWidth - 2;
        this.thumbs.forEach((thumb, i) => {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      };
      if (this.prev) this.prev.addEventListener('click', () => this.slides.scrollBy({ left: -this.slideStep(), behavior: 'smooth' }));
      if (this.next) this.next.addEventListener('click', () => this.slides.scrollBy({ left: this.slideStep(), behavior: 'smooth' }));
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.index))));
      this.slides.addEventListener('scroll', sync, { passive: true });
      sync();
    }

    /* ---------- variants ---------- */

    currentVariant() {
      if (!this.selected.length) return this.product.variants[0];
      return this.product.variants.find((variant) => this.selected.every((value, index) => variant['option' + (index + 1)] === value));
    }

    markAvailability() {
      this.querySelectorAll('.hf-pdp__option').forEach((fieldset) => {
        const index = Number(fieldset.dataset.index);
        fieldset.querySelectorAll('.hf-pdp__value').forEach((wrapper) => {
          const value = wrapper.querySelector('input').value;
          const possible = this.product.variants.some(
            (v) => v.available && v['option' + (index + 1)] === value && this.selected.every((sel, i) => i === index || v['option' + (i + 1)] === sel)
          );
          wrapper.classList.toggle('is-unavailable', !possible);
        });
      });
    }

    update(scrollToImage) {
      const variant = this.currentVariant();

      this.querySelectorAll('.hf-pdp__option').forEach((fieldset) => {
        const small = fieldset.querySelector('small');
        if (small) small.textContent = this.selected[Number(fieldset.dataset.index)];
      });
      this.markAvailability();

      if (!variant) {
        this.submit.textContent = this.strings.unavailable;
        this.submit.disabled = true;
        return;
      }

      if (this.idInput) {
        this.idInput.value = variant.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.priceEl) {
        let price = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          price += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
        }
        this.priceEl.innerHTML = price + formatMoney(variant.price);
      }

      if (this.skuEl) {
        this.skuEl.hidden = !variant.sku;
        const span = this.skuEl.querySelector('span');
        if (span) span.textContent = variant.sku || '';
      }

      this.submit.textContent = variant.available ? this.strings.addToCart : this.strings.soldOut;
      this.submit.disabled = !variant.available;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (scrollToImage && variant.featured_media && this.slides) {
        const slide = this.slides.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) this.goTo(Array.prototype.indexOf.call(this.slides.children, slide));
      }
    }

    /* ---------- cart ---------- */

    add() {
      const variant = this.currentVariant();
      if (!variant || !variant.available || this.submit.disabled) return;

      this.errorEl.hidden = true;
      this.submit.disabled = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      body.set('id', variant.id);
      if (!body.has('quantity')) body.append('quantity', 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const addUrl = (window.routes && window.routes.cart_add_url) || root + 'cart/add';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          this.submit.disabled = false;
          if (response.status) {
            this.errorEl.textContent = response.description || response.message || this.strings.error;
            this.errorEl.hidden = false;
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(response);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          }
        })
        .catch(() => {
          this.submit.disabled = false;
          this.errorEl.textContent = this.strings.error;
          this.errorEl.hidden = false;
        });
    }
  }

  customElements.define('hf-product', HfProduct);
})();
